import {mapState, mapGetters, mapActions} from 'vuex'
import numeral from "numeral";
import {flags, isoCountries} from "@/helpers/countries";
import Swal from "sweetalert2";

String.prototype.plural = function(revert){
    var plural = {
        '(quiz)$'               : "$1zes",
        '^(ox)$'                : "$1en",
        '([m|l])ouse$'          : "$1ice",
        '(matr|vert|ind)ix|ex$' : "$1ices",
        '(x|ch|ss|sh)$'         : "$1es",
        '([^aeiouy]|qu)y$'      : "$1ies",
        '(hive)$'               : "$1s",
        '(?:([^f])fe|([lr])f)$' : "$1$2ves",
        '(shea|lea|loa|thie)f$' : "$1ves",
        'sis$'                  : "ses",
        '([ti])um$'             : "$1a",
        '(tomat|potat|ech|her|vet)o$': "$1oes",
        '(bu)s$'                : "$1ses",
        '(alias)$'              : "$1es",
        '(octop)us$'            : "$1i",
        '(ax|test)is$'          : "$1es",
        '(us)$'                 : "$1es",
        '([^s]+)$'              : "$1s"
    };
    var singular = {
        '(quiz)zes$'             : "$1",
        '(matr)ices$'            : "$1ix",
        '(vert|ind)ices$'        : "$1ex",
        '^(ox)en$'               : "$1",
        '(alias)es$'             : "$1",
        '(octop|vir)i$'          : "$1us",
        '(cris|ax|test)es$'      : "$1is",
        '(shoe)s$'               : "$1",
        '(o)es$'                 : "$1",
        '(bus)es$'               : "$1",
        '([m|l])ice$'            : "$1ouse",
        '(x|ch|ss|sh)es$'        : "$1",
        '(m)ovies$'              : "$1ovie",
        '(s)eries$'              : "$1eries",
        '([^aeiouy]|qu)ies$'     : "$1y",
        '([lr])ves$'             : "$1f",
        '(tive)s$'               : "$1",
        '(hive)s$'               : "$1",
        '(li|wi|kni)ves$'        : "$1fe",
        '(shea|loa|lea|thie)ves$': "$1f",
        '(^analy)ses$'           : "$1sis",
        '((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$': "$1$2sis",
        '([ti])a$'               : "$1um",
        '(n)ews$'                : "$1ews",
        '(h|bl)ouses$'           : "$1ouse",
        '(corpse)s$'             : "$1",
        '(us)es$'                : "$1",
        's$'                     : ""
    };
    var irregular = {
        'move'   : 'moves',
        'foot'   : 'feet',
        'goose'  : 'geese',
        'sex'    : 'sexes',
        'child'  : 'children',
        'man'    : 'men',
        'tooth'  : 'teeth',
        'person' : 'people'
    };
    var uncountable = [
        'sheep',
        'fish',
        'deer',
        'moose',
        'series',
        'species',
        'money',
        'rice',
        'information',
        'equipment'
    ];
    // save some time in the case that singular and plural are the same
    if(uncountable.indexOf(this.toLowerCase()) >= 0)
        return this;
    // check for irregular forms
    for(let word in irregular){
        if(revert){
            var pattern = new RegExp(irregular[word]+'$', 'i');
            var replace = word;
            // eslint-disable-next-line no-redeclare
        } else{ var pattern = new RegExp(word+'$', 'i');
            // eslint-disable-next-line no-redeclare
            var replace = irregular[word];
        }
        if(pattern.test(this))
            return this.replace(pattern, replace);
    }
    if(revert) var array = singular;
    // eslint-disable-next-line no-redeclare
    else  var array = plural;
    // check for matches using regular expressions
    for(let reg in array){
        // eslint-disable-next-line no-redeclare
        var pattern = new RegExp(reg, 'i');
        if(pattern.test(this))
            return this.replace(pattern, array[reg]);
    }
    return this;
}

export const authComputed = {
    ...mapState('auth', {
        currentUser: (state) => state.currentUser,
    }),
    ...mapGetters('auth', ['loggedIn']),
}

export const layoutComputed = {
    ...mapState('layout', {
        layoutType: (state) => state.layoutType,
        leftSidebarType: (state) => state.leftSidebarType,
        layoutWidth: (state) => state.layoutWidth,
        topbar: (state) => state.topbar,
        loader: (state) => state.loader
    })
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const getCountryName = (countryCode) => {
    countryCode = countryCode.toUpperCase()
    if (isoCountries.hasOwnProperty(countryCode)) {
        return isoCountries[countryCode];
    } else {
        return countryCode;
    }
};

export const flagCdnImageLink = (countryCode) => {
    countryCode = countryCode.toLowerCase();
    return `https://flagcdn.com/64x48/${countryCode}.png`
}

export const getCountryFlag = (countryCode, imageFormat=true) => {

    if (imageFormat) {
        try {
            return flagCdnImageLink(countryCode);
        } catch (e) {
            return null;
        }
    }

    countryCode = countryCode.toUpperCase()
    if (flags.hasOwnProperty(countryCode)) {
        return flags[countryCode];
    }

    return countryCode;
};

export const convertToSQLDate = (date) => {
    if (typeof date === 'string') {
        date = new Date(date);
    }

    let month = '' + (date.getMonth() + 1),
        day = '' + date.getDate(),
        year = date.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
};

export const convertToLocaleTimeString = (date, config = {}) => {
    config = {year: 'numeric', month: 'long', day: 'numeric', ...config};
    return new Date(date).toLocaleDateString(undefined, config);
}

export const serbianDateFormat = (date) => {
    if (typeof date === 'string') {
        date = new Date(date);
    }

    let month = '' + (date.getMonth() + 1),
        day = '' + date.getDate(),
        year = date.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [day, month, year].join('.') + '.'
}

export const timeSince = (date) => {
    if (typeof date === 'string') {
        date = new Date(date);
    }

    var seconds = Math.floor((new Date() - date) / 1000);

    var interval = seconds / 31536000;

    if (interval > 1) {
        return Math.floor(interval) + " years";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + (Math.floor(interval) === 1 ? " day" : " days");
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + (Math.floor(interval) === 1 ? " hour" : " hours");
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + (Math.floor(interval) === 1 ? " minute" : " minutes");
    }
    return Math.floor(seconds) + (Math.floor(interval) === 1 ? " second" : " seconds");
}

export const slugify = (text) => {
    return text
        .toString()                     // Cast to string
        .toLowerCase()                  // Convert the string to lowercase letters
        .normalize('NFD')       // The normalize() method returns the Unicode Normalization Form of a given string.
        .trim()                         // Remove whitespace from both sides of a string
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w-]+/g, '')       // Remove all non-word chars
        .replace(/--+/g, '-');        // Replace multiple - with single -
}

export const markdownText = (text) => {
    const boldRegex = /\*\*(.*?)\*\*/gm;
    return text.replace(boldRegex, '<b>$1</b>');
}

export const compactNumber = (number) => {
    return numeral(number).format('0.[0]a')
}

export const snakeToWords = (text) => {
    return text.replace(/_/g, " ")
}

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const capitalize = (string) => {
    //split the above string into an array of strings
    //whenever a blank space is encountered
    const arr = string.split(" ");
    //loop through each element of the array and capitalize the first letter.
    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);

    }

    //Join all the elements of the array back into a string
    //using a blankspace as a separator
    const str2 = arr.join(" ");

    return str2
}

export const env = (envVarName) => {
    return process.env[envVarName]
}

export const Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: false,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})
